import { render, staticRenderFns } from "./boxCitySelectJgsz.vue?vue&type=template&id=fdd0cc72&scoped=true"
import script from "./boxCitySelectJgsz.vue?vue&type=script&lang=js"
export * from "./boxCitySelectJgsz.vue?vue&type=script&lang=js"
import style0 from "./boxCitySelectJgsz.vue?vue&type=style&index=0&id=fdd0cc72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0cc72",
  null
  
)

export default component.exports